class Logger {
  // //
  static level = 0
  static levelMap = {
    nolog: 0,
    fatal: 1,
    error: 2,
    warn: 3,
    info: 4,
    debug: 5,
    trace: 6,
  }
  static showTags = []
  // static showTags = ['R!']

  static setLevel(levelName) {
    // console.info('levelName', levelName)
    Logger.level = Logger.levelMap[levelName.toLowerCase()]
  }

  static fatal() {
    if (Logger.level >= Logger.levelMap['fatal']) {
      console.fatal(...arguments)
    }
  }

  static error() {
    if (Logger.level >= Logger.levelMap['error']) {
      console.error(...arguments)
    }
  }

  static warn() {
    if (Logger.level >= Logger.levelMap['warn']) {
      console.warn(...arguments)
    }
  }

  static info() {
    if (Logger.level >= Logger.levelMap['info']) {
      console.info(...arguments)
    }
  }

  static debug() {
    if (Logger.level >= Logger.levelMap['debug']) {
      console.debug(...arguments)
    }
  }

  static special(tag, ...args) {
    if (Logger.showTags.includes(tag)) {
      console.debug(...args)
    }
  }
}

console.log = function() {
  if (Logger.level >= Logger.levelMap['warn']) {
    console.warn(
      'DO NOT USE console.log(), USE Logger.fatal()/error()/warn()/info()/debug() INSTEAD',
    )

    var stackTrace = new Error().stack // Only tested in latest FF and Chrome
    stackTrace = stackTrace.replace(/^Error\s+/, '') // Sanitize Chrome
    var callerRow = stackTrace.split('\n')[1] // 1st item is this, 2nd item is caller
    var [funcname, paths] = callerRow.split('@')
    var lastpath = paths.split('?!')
    // callerName = callerName.replace(/^\s+at Object./, '') // Sanitize Chrome
    // callerName = callerName.replace(/ \(.+\)$/, '') // Sanitize Chrome
    // callerName = callerName.replace(/@.+/, '') // Sanitize Firefox
    console.warn(
      `... found in '${funcname}()'`,
      lastpath[lastpath.length - 1],
      '(ignore line number)',
    )
  }
}

export default Logger
